import type { FieldPath } from 'react-hook-form';
import { z } from 'zod';

// Main validation schema using nested structures
export const subgroupFormSchema = z.object({
    name: z.string().min(1, { message: 'Required' }),
    description: z.string().optional(),
    parentGroupName: z.string().optional(),
});

export type SubgroupFormData = z.infer<typeof subgroupFormSchema>;

export const defaultSubgroupFormValues: SubgroupFormData = {
    name: '',
    description: '',
    parentGroupName: '',
};

export const getFieldsToValidate = (): FieldPath<SubgroupFormData>[] => {
    return ['name'];
};
